export const MAX_RATE = 5;
export const MIN_POSITIVE_RATE = 5;
export const REVIEW_URL = 'https://apps.shopify.com/sling#reviews';
// spreadsheet url: https://docs.google.com/spreadsheets/d/1cE4DuIymJd6HBF_KwykUXWqGaO7SWNVFmWGuRfVh7Sg/edit#gid=0
export const FEEDBACK_URL =
  'https://script.google.com/macros/s/AKfycbwISZfQhovvgg06AypcOTt7SHf8REEK0vvZ7NmS1ge1liNqSs4/exec';
export const MODAL_FREQUENCY_DAYS = 30;
export const MIN_SHOPIFY_EXPERIENCE_DAYS = 7;

export const RATE_STEPS = [
  { action: 'How would you rate your experience with Sling?' },
  {
    action:
      'Love the app? Share your thoughts on Shopify to help other businesses find a scheduling solution.',
  },
  { action: 'Tell us what went wrong. We’ll work on it.' },
  {
    action: 'We value your opinion and will be working on it soon.',
    icon: 'checkmark',
  },
];
